import { cloneDeep, get } from "lodash"
import { ApplicationStep3, PrivateSolicitor } from "../ApplicationStep3.class";
import { StructureStatusEnum } from "../../enum/structure-status.enum";
import { SubmitDocuments } from "../CooSubmission.class";


// Dummy data
// export const StageD1NewJSON = data.StageD1NewJSON;
// export const StageD1NewJsonV2 = data.StageD1NewJsonV2;
// export const StageD1NewJsonV3 = data.StageD1NewJsonV3;
// export const StageD2NewJson = data.StageD2NewJson;
// export const StageD2NewJsonV2 = data.StageD2NewJsonV2;
// export const StageD2NewJsonV3 = data.StageD2NewJsonV3;
// export const StageD4NewJsonV2 = data.StageD4NewJsonV2;



export class StageDSolicitorApplication extends ApplicationStep3{
  uuid : string;
  group_uuid : string;

  constructor(initial?: StageDSolicitorApplication){
    super(initial);
    this.uuid = get(initial, 'uuid', "");
    this.group_uuid = get(initial, 'group_uuid', "");

  }

}

export class StageDSolicitorApplicationForm{
  solicitors: StageDSolicitorApplication[]
  constructor(initial?: StageDSolicitorApplication){
    this.solicitors = get(initial, 'solicitors', []);
  }
}

export type StageDMessageType = "GENERIC" | "SOLICITOR";
export type OwnerType = "CURRENT_OWNER" | "PROPOSED_OWNER" | "OUTGOING_OWNER";
export type SolicitorRequestType = "MORTGAGE" | "CONVEYANCING" | "BOTH"

export class StageDReviewApplication {
  private static readonly IPA_FOLDER_NAME = 'In-Principle Approval';
  private static readonly CURRENT_FP_FOLDER_NAME = 'Financial Plan for Current Owners';
  private static readonly PROPOSED_FP_FOLDER_NAME = 'Financial Plan for Proposed Owners';
  private static readonly COMBINED_FP_FOLDER_NAME = 'Combine Financial Proposed Owners And Current Owners';
  private static readonly LEGAL_DOCS_FOLDER_NAME = 'Legal Documents';

  application_uuid: string;
  message_info: StageDMessageInfo[];
  folders: StageDocumentsInfo[];
  message_type?: StageDMessageType;
  solicitor_group_uuid?: string[];
  solicitor_parent_uuid?: string[];
  solicitor_message_info?: StageDMessageInfo[];
  hasFinancialPlan?: boolean;
  hasLegalDocsReady?: boolean;
  endorse_forms?: StageDEndorseFormInfo[];

  constructor(initial?: StageDReviewApplication) {
    this.application_uuid = get(initial, 'application_uuid', '');
    this.message_info = get(initial, 'message_info', []);
    this.folders = get(initial, 'folders', []);
    this.message_type = get(initial, 'message_type', 'GENERIC');
    this.solicitor_group_uuid = get(initial, 'solicitor_group_uuid', []);
    this.solicitor_parent_uuid = get(initial, 'solicitor_parent_uuid', []);
    this.solicitor_message_info = get(initial, 'solicitor_message_info', []);
    this.endorse_forms = get(initial, 'endorse_forms', []);
  }

  stageD1ProcessFolders?() {
    this.message_type = this.message_info.some((e) => e.type === 'SOLICITOR') ? 'SOLICITOR' : 'GENERIC';
    this.solicitor_message_info = this.message_info.filter((e) => e.type === 'SOLICITOR');
    this.message_info = this.message_info.filter((e) => e.type === 'GENERIC');

    // *IMPT NOTE: Filter is added to prevent IPA from showing in D1, when paged is refresh and after officer has approved case.
    this.folders = this.folders.filter(
      (e) =>
        e.name !== StageDReviewApplication.IPA_FOLDER_NAME &&
        e.name !== StageDReviewApplication.CURRENT_FP_FOLDER_NAME &&
        e.name !== StageDReviewApplication.PROPOSED_FP_FOLDER_NAME &&
        e.name !== StageDReviewApplication.COMBINED_FP_FOLDER_NAME
    );
  }

  stageD2ProcessFolders?() {
    this.message_type = this.message_info.some((e) => e.type === 'SOLICITOR') ? 'SOLICITOR' : 'GENERIC';
    this.solicitor_message_info = this.message_info.filter((e) => e.type === 'SOLICITOR');
    this.message_info = this.message_info.filter((e) => e.type === 'GENERIC');

    this.hasFinancialPlan = this.folders.some(
      (e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME || e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME
    );

    // Remove financial plan folders after setting flag
    this.folders = this.folders.filter(
      (e) =>
        e.name !== StageDReviewApplication.CURRENT_FP_FOLDER_NAME &&
        e.name !== StageDReviewApplication.PROPOSED_FP_FOLDER_NAME &&
        e.name !== StageDReviewApplication.COMBINED_FP_FOLDER_NAME &&
        !e.name.startsWith("Financial Plan for Solicitor")
    );

  }

  stageD4ProcessFolders?(structure_status: StructureStatusEnum) {
    this.message_type = this.message_info.some((e) => e.type === 'SOLICITOR') ? 'SOLICITOR' : 'GENERIC';
    this.solicitor_message_info = this.message_info.filter((e) => e.type === 'SOLICITOR');
    this.message_info = this.message_info.filter((e) => e.type === 'GENERIC');

    this.hasFinancialPlan = this.folders.some(
      (e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME || e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME
    );
    this.hasLegalDocsReady = this.folders.some((e) => e.name === StageDReviewApplication.LEGAL_DOCS_FOLDER_NAME);

    console.groupCollapsed(`Stage D4 Process Folders - Status: ${structure_status}`);
    console.log('Initial folders:', this.folders);
    
    const requestFolders = this.folders.filter((item) => item.is_request_document);

    if (structure_status === StructureStatusEnum.incoming) {
      //Only show proposed
      console.log('Only show proposed');
      this.folders = this.folders.filter((e) => e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME).concat(requestFolders);
    } else if (structure_status === StructureStatusEnum.outgoing) {
      //Only show current
      console.log('Only show current');
      this.folders = this.folders.filter((e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME).concat(requestFolders);
    } else if (structure_status === StructureStatusEnum.retaining) {
      //Show current and proposed
      console.log('Show both current and proposed');
      this.folders = this.folders
        .filter((e) => e.name === StageDReviewApplication.CURRENT_FP_FOLDER_NAME || e.name === StageDReviewApplication.PROPOSED_FP_FOLDER_NAME)
        .concat(requestFolders);
    }

    const formatted_folders = cloneDeep(this.folders);

    const allCommentsFromFormattedFolders = formatted_folders.map((e) => {
      let latestComment = e.comments;
      if (latestComment && latestComment.length > 0) {
        latestComment = latestComment.slice(-1);
      }
      return new StageDocumentsInfo({ ...e, comments: [...latestComment] });
    });

    this.folders = allCommentsFromFormattedFolders;

    console.log('Folders after processing:', this.folders);
    console.log('Has legal docs ready:', this.hasLegalDocsReady);
    console.groupEnd();
  }

  stageDDefaultJSON?() {
    this.folders = [];
    this.message_info = [];
  }

  stageEProcessFolders?() {
    const temp_folders = [...this.folders];
    const refer_folder_name = 'Legal Documents';

    this.folders = temp_folders.filter((e) => e.name === refer_folder_name);
  }

  json?() {
    return this;
  }
}



export class StageDMessageInfo{
  uuid:string
  due_date: string
  parent_uuid?: string
  group_uuid: string
  subject: string
  message: string
  received_date: string
  type: StageDMessageType | any
  status?: string
  reply?: string
  replied_by?: string
  replied_at?: string
  is_saved?: boolean
  owner_type?: OwnerType
  solicitor_request_type?: SolicitorRequestType

  constructor(initial?: StageDMessageInfo){
    this.uuid = get(initial,'uuid','');
    this.parent_uuid = get(initial,'parent_uuid','');
    this.group_uuid = get(initial,'group_uuid','');
    this.due_date = get(initial,'due_date','');
    this.subject = get(initial,'subject','');
    this.message = get(initial,'message','');
    this.received_date = get(initial,'received_date','');
    this.status = get(initial,'status','');
    this.type = get(initial,'type','GENERIC');
    this.owner_type = get(initial, 'owner_type', undefined);
    this.solicitor_request_type = get(initial, 'solicitor_request_type', undefined);

    this.reply = get(initial,'reply','');
    this.replied_by = get(initial,'replied_by','')
    this.replied_at = get(initial,'replied_at','')
    this.is_saved = get(initial,'is_saved',false);
  }
}
export class StageDocumentsInfo{

  uuid: string;
  name: string;
  due_date: string;
  received_date: string;
  is_request_document: boolean;
  comments: StageDCommentsInfo[];
  documents?: SubmitDocuments[];

  constructor(initial?: StageDocumentsInfo){
    this.uuid = get(initial,'uuid','');
    this.name = get(initial,'name','');
    this.due_date = get(initial,'due_date','');
    this.received_date = get(initial,'received_date','');
    this.is_request_document = get(initial,'is_request_document',false);
    this.comments = get(initial,'comments',[]).map(comment => new StageDCommentsInfo(comment));
    this.documents = get(initial, 'documents', []).map(document => new SubmitDocuments(document));
  }
}

export class StageDEndorseFormInfo{
  id: number;
  title: string;
  received_date: string;
  due_date: string;
  owners: StageDEndorseOwnerInfo[];
  occupiers: StageDEndorseOccupierInfo[];
  signify_document_id: number;
  signing_link: string;
  biome_status: string;
  signify_status: string;
  signing_require: boolean;

  constructor(initial?:StageDEndorseFormInfo){
    this.id = get(initial,'id',0);
    this.title = get(initial,'title','');
    this.received_date = get(initial,'received_date','');
    this.due_date = get(initial,'due_date','');
    this.owners = get(initial,'owners',[]);
    this.occupiers = get(initial,'occupiers',[]);
    this.signify_document_id = get(initial,'signify_document_id',0);
    this.signing_link = get(initial,'signing_link','');
    this.biome_status = get(initial,'biome_status','');
    this.signify_status = get(initial,'signify_status','');
    this.signing_require = get(initial,'signing_require', false);
  }
}

export class StageDCommentsInfo{
  uuid: string;
  text: string;
  is_replied?: boolean;
  replied_by?: string;
  replied_at?: string;
  documents: StageDDocumentsInfo[];

  constructor(initial?: StageDCommentsInfo){
    this.uuid = get(initial,'uuid','');
    this.text = get(initial,'text','');
    this.is_replied = get(initial,'is_replied',false);
    this.replied_by = get(initial,'replied_by','');
    this.replied_at = get(initial,'replied_at','');
    this.documents = get(initial,'documents',[]).map(document => new StageDDocumentsInfo(document));
  }
}

export class StageDDocumentsInfo{
  uuid: string;
  key: string;
  name: string;
  submitted_date?: string;
  size: number;

  constructor(initial?: StageDDocumentsInfo){
    this.uuid = get(initial,'uuid','');
    this.key = get(initial,'key','');
    this.name = get(initial,'name','');
    this.submitted_date = get(initial, 'submitted_date', "");
    this.size = get(initial,'size',0);
  }
}


export class StageDSolicitorUpdate{
  application_uuid: string | null;
  parent_uuid: string;
  group_uuid: string;
  infos : StageDSolicitor[]

  constructor(initial?:StageDSolicitorUpdate){
    this.application_uuid = get(initial,'application_uuid', "");
    this.parent_uuid      = get(initial,'parent_uuid', "");
    this.group_uuid       = get(initial,'group_uuid', "");
    this.infos            = get(initial,'infos', []);
  }

  setApplicationUuid(application_uuid:string | null){
    this.application_uuid = application_uuid;
  }
  setParentUuid(parent_uuid:string){
    this.parent_uuid = parent_uuid;
  }
  setGroupUUid(group_uuid:string){
    this.group_uuid = group_uuid;
  }
  setProposedSolicitor(initial:StageDSolicitorApplication, solicitorRequestType: SolicitorRequestType = "BOTH"){
    const private_solicitor:PrivateSolicitor = initial.proposed.private_solicitor;
    const conveyancing_solicitor:PrivateSolicitor = initial.proposed.conveyancing_private_solicitor;

    switch (solicitorRequestType) {
      case "MORTGAGE": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        this.infos = [mortgateSolicitor];
        break;
      }

      case "CONVEYANCING": {
        const conveyancingSolicitor = new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
        this.infos = [conveyancingSolicitor];
        break;
      }

      case "BOTH": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });

        const conveyancingSolicitor = initial.proposed.private_solicitor.represented_same_solicitor ? new StageDSolicitor({...mortgateSolicitor, type:"CONVEYANCING"}) :
        new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });

        this.infos = [mortgateSolicitor, conveyancingSolicitor];
      }
    }
  }

  setCurrentSolicitor(initial:StageDSolicitorApplication, solicitorRequestType: SolicitorRequestType = "BOTH"){
    const private_solicitor:PrivateSolicitor = initial.current.private_solicitor;
    const conveyancing_solicitor:PrivateSolicitor = initial.current.conveyancing_private_solicitor;

    switch (solicitorRequestType) {
      case "MORTGAGE": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        this.infos = [mortgateSolicitor];
        break;
      }
      case "CONVEYANCING": {
        const conveyancingSolicitor = new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
        this.infos = [conveyancingSolicitor];
        break;
      }
      case "BOTH": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });

        const conveyancingSolicitor = initial.proposed.private_solicitor.represented_same_solicitor ? new StageDSolicitor({...mortgateSolicitor, type:"CONVEYANCING"}) :
        new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });

        this.infos = [mortgateSolicitor, conveyancingSolicitor];
      }
    }
  }

  setOutgoingSolicitor(initial:StageDSolicitorApplication, solicitorRequestType: SolicitorRequestType = "BOTH"){
    const private_solicitor:PrivateSolicitor = initial.outgoing.private_solicitor;
    const conveyancing_solicitor:PrivateSolicitor = initial.outgoing.conveyancing_private_solicitor;
    switch (solicitorRequestType) {
      case "MORTGAGE": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });
        this.infos = [mortgateSolicitor];
        break;
      }
      case "CONVEYANCING": {
        const conveyancingSolicitor = new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });
        this.infos = [conveyancingSolicitor];
        break;
      }
      case "BOTH": {
        const mortgateSolicitor = new StageDSolicitor({
          type:"MORTGAGE",
          name: private_solicitor.name_of_firm,
          email: private_solicitor.email_of_solicitor,
          uen: private_solicitor.uen,
        });

        const conveyancingSolicitor = initial.proposed.private_solicitor.represented_same_solicitor ? new StageDSolicitor({...mortgateSolicitor, type:"CONVEYANCING"}) :
        new StageDSolicitor({
          type:"CONVEYANCING",
          name: conveyancing_solicitor.name_of_firm,
          email: conveyancing_solicitor.email_of_solicitor,
          uen: conveyancing_solicitor.uen,
        });

        this.infos = [mortgateSolicitor, conveyancingSolicitor];
      }
    }
  }

  json(){
    return this;
  }
}


export class StageDSolicitorParent{
  solicitor: StageDSolicitorUpdate[];
  constructor(initial?:StageDSolicitorParent){
    this.solicitor = get(initial,'solicitor',[]);
  }


}

export class StageDEndorseOwnerInfo{
  name: string;
  uinfin: string;
  endorsement_date?: string;
  notified?: boolean;

  constructor(initial?:StageDEndorseOwnerInfo){
    this.name = get(initial,'name','');
    this.uinfin = get(initial,'uinfin','');
    this.endorsement_date = get(initial,'endorsement_date','');
  }
}

export class StageDEndorseOccupierInfo{
  name: string;
  uinfin: string;
  endorsement_date?: string;
  notified?: boolean;

  constructor(initial?:StageDEndorseOwnerInfo){
    this.name = get(initial,'name','');
    this.uinfin = get(initial,'uinfin','');
    this.endorsement_date = get(initial,'endorsement_date','');
  }
}

class StageDSolicitor{
  type: "MORTGAGE" | "CONVEYANCING" | null
  name: string
  email: string
  uen: string

  constructor(initial:StageDSolicitor){
    this.type = get(initial,'type', null);
    this.name = get(initial,'name', "");
    this.email = get(initial,'email', "");
    this.uen = get(initial,'uen', "");

  }
}

export class StageDCurrentFinancialPlan{
  prepared_on: string
  outstanding_mortgage_loan: number;
  total_cpf_refund_to_outgoing: number;
  cpf_refund_co: CpfRefundCo[];
  resale_levy: number;
  seller_stamp_duty: number;
  conveyancing_fees: ConveyancingFeesCo;
  property_registration_fees: PropertyRegistrationFeesCo;
  outstanding_late_payment_charge: number;
  outstanding_fi_premium_and_admin_fee: number;
  total_payment_required: number;
  others_fee: CurrentFinancialPlanOthersFee[];
  tentative_completion_date?: string;
  scheduled_completion_date?: string;
  actual_completion_date?: string;
  total_solicitor_fee_by_cash?: number

  constructor(initial?:StageDCurrentFinancialPlan){
    this.prepared_on = get(initial,'prepared_on', "");
    this.outstanding_mortgage_loan = get(initial,'outstanding_mortgage_loan', 0);
    this.total_cpf_refund_to_outgoing = get(initial,'total_cpf_refund_to_outgoing', 0);
    this.cpf_refund_co = get(initial,'cpf_refund_co', []);
    this.resale_levy = get(initial,'resale_levy', 0);
    this.seller_stamp_duty = get(initial,'seller_stamp_duty', 0);
    this.conveyancing_fees = get(initial,'conveyancing_fees', new ConveyancingFeesCo({
      transfer: 0,
      miscellaneous: 0,
      tdm: 0,
      noticeOfDeath: 0
    }));
    this.property_registration_fees = get(initial,'property_registration_fees', new PropertyRegistrationFeesCo({
      registrar: 0,
      tdm: 0,
      noticeOfDeath: 0
    }));
    this.outstanding_late_payment_charge = get(initial,'outstanding_late_payment_charge', 0);
    this.outstanding_fi_premium_and_admin_fee = get(initial,'outstanding_fi_premium_and_admin_fee', 0);
    this.total_payment_required = get(initial,'total_payment_required', 0);
    this.others_fee = get(initial,'others_fee',[]).map(othersFee => new CurrentFinancialPlanOthersFee(othersFee));
    this.total_solicitor_fee_by_cash = get(initial, 'total_solicitor_fee_by_cash', 0);
  }
}

class CpfRefundCo{
  name: string;
  amount: number;

  constructor(initial?:CpfRefundCo){
    this.name = get(initial,'name', "");
    this.amount = get(initial,'amount', 0);
  }
}

class CurrentFinancialPlanOthersFee{
  fee_name: string;
  amount: number;

  constructor(initial?:CurrentFinancialPlanOthersFee){
    this.fee_name = get(initial,'fee_name', "");
    this.amount = get(initial,'amount', 0);
  }
}

class ConveyancingFeesCo{
  transfer: number;
  miscellaneous: number;
  tdm: number;
  noticeOfDeath: number;
  gstTransfer?: number;
  byCashTransfer?: number;
  gstMiscellaneous?: number;
  byCashMiscellaneous?: number;
  gstTDM?: number;
  byCashTDM?: number;
  gstNoticeOfDeath?: number;
  byCashNoticeOfDeath?: number;

  constructor(initial?:ConveyancingFeesCo){
    this.transfer = get(initial,'transfer', 0);
    this.gstTransfer = get(initial,'gstTransfer', 0);
    this.byCashTransfer = get(initial,'byCashTransfer', 0);
    this.miscellaneous = get(initial,'miscellaneous', 0);
    this.gstMiscellaneous = get(initial,'gstMiscellaneous', 0);
    this.byCashMiscellaneous = get(initial,'byCashMiscellaneous', 0);
    this.tdm = get(initial,'tdm', 0);
    this.gstTDM = get(initial,'gstTDM', 0);
    this.byCashTDM = get(initial,'byCashTDM', 0);
    this.noticeOfDeath = get(initial,'noticeOfDeath', 0);
    this.gstNoticeOfDeath = get(initial,'gstNoticeOfDeath', 0);
    this.byCashNoticeOfDeath = get(initial,'byCashNoticeOfDeath', 0);
  }
}

class PropertyRegistrationFeesCo{
  registrar: number;
  tdm: number;
  noticeOfDeath: number;
  gstRegistrar?: number;
  byCashRegistrar?: number;
  gstTdm?: number;
  byCashTdm?: number;
  gstNoticeOfDeath?: number;
  byCashNoticeOfDeath?: number;

  constructor(initial?:PropertyRegistrationFeesCo){
    this.registrar = get(initial,'registrar', 0);
    this.gstRegistrar = get(initial,'gstRegistrar', 0);
    this.byCashRegistrar = get(initial,'byCashRegistrar', 0);
    this.tdm = get(initial,'tdm', 0);
    this.gstTdm = get(initial,'gstTdm', 0);
    this.byCashTdm = get(initial,'byCashTdm', 0);
    this.noticeOfDeath = get(initial,'noticeOfDeath', 0);
    this.gstNoticeOfDeath = get(initial,'gstNoticeOfDeath', 0);
    this.byCashNoticeOfDeath = get(initial,'byCashNoticeOfDeath', 0);
  }
}

export class StageDProposedFinancialPlan{
  prepared_on: string;
  proposed_payment_allocation_payable_cpf: number;
  proposed_payment_allocation_payable_loan: number;
  proposed_payment_allocation_payable_cash: number;
  proposed_payment_allocation_total_payable: number;
  total_payments_required: number;
  total_payments_required_outstanding_mortgage_loan: number;
  total_payments_required_cpf_refund: number;
  total_payments_required_stamp_fees: number;
  total_payments_required_conveyancing_fees: number;
  total_payments_required_property_registration_fees: number;
  repayment_period: string;
  repayment_interest_rate: string;
  monthly_installment: number;
  monthly_installment_by_cpf: number;
  monthly_installment_by_cpf_owner: MonthlyInstalmentByCpfOwner[];
  monthly_installment_by_cash: number;
  home_protection_schemes: HomeProtectionSchemes[];
  others_fee: CurrentFinancialPlanOthersFee[];
  tentative_completion_date: string;
  scheduled_completion_date: string;
  actual_completion_date: string;
  proposed_payment_allocation_payable_cpf_each: ProposedPaymentAllocationPayableCpfEach[];
  total_solicitor_fee_by_cash?: number;

  constructor(initial?:StageDCurrentFinancialPlan){
    this.prepared_on = get(initial,'prepared_on', "");
    this.proposed_payment_allocation_payable_cpf = get(initial,'proposed_payment_allocation_payable_cpf', 0);
    this.proposed_payment_allocation_payable_loan = get(initial,'proposed_payment_allocation_payable_loan', 0);
    this.proposed_payment_allocation_payable_cash = get(initial,'proposed_payment_allocation_payable_cash', 0);
    this.proposed_payment_allocation_total_payable = get(initial,'proposed_payment_allocation_total_payable', 0);
    this.total_payments_required = get(initial,'total_payments_required', 0);
    this.total_payments_required_outstanding_mortgage_loan = get(initial,'total_payments_required_outstanding_mortgage_loan', 0);
    this.total_payments_required_cpf_refund = get(initial,'total_payments_required_cpf_refund', 0);
    this.total_payments_required_stamp_fees = get(initial,'total_payments_required_stamp_fees', 0);
    this.total_payments_required_conveyancing_fees = get(initial,'total_payments_required_conveyancing_fees', 0);
    this.total_payments_required_property_registration_fees = get(initial,'total_payments_required_property_registration_fees', 0);
    this.repayment_period = get(initial,'repayment_period', "");
    this.repayment_interest_rate = get(initial,'repayment_interest_rate', "");
    this.monthly_installment = get(initial,'monthly_installment', 0);
    this.monthly_installment_by_cpf = get(initial,'monthly_installment_by_cpf', 0);
    this.monthly_installment_by_cpf_owner = get(initial,'monthly_installment_by_cpf_owner', []).map(owner => new MonthlyInstalmentByCpfOwner(owner));
    this.monthly_installment_by_cash = get(initial,'monthly_installment_by_cash', 0);
    this.home_protection_schemes = get(initial,'home_protection_schemes', []).map(scheme => new HomeProtectionSchemes(scheme));
    this.others_fee = get(initial,'others_fee',[]).map(othersFee => new CurrentFinancialPlanOthersFee(othersFee));
    this.tentative_completion_date = get(initial,'tentative_completion_date', "");
    this.scheduled_completion_date = get(initial,'scheduled_completion_date', "");
    this.actual_completion_date = get(initial,'actual_completion_date', "");
    this.proposed_payment_allocation_payable_cpf_each = get(initial,'proposed_payment_allocation_payable_cpf_each', []).map(owner => new ProposedPaymentAllocationPayableCpfEach(owner));
    this.total_solicitor_fee_by_cash = get(initial,'total_solicitor_fee_by_cash', 0);
  }
}

class MonthlyInstalmentByCpfOwner{
  name: string;
  amount: number;
  balance: boolean

  constructor(initial?:MonthlyInstalmentByCpfOwner){
    this.name = get(initial,'name', "");
    this.amount = get(initial,'amount', 0);
    this.balance = get(initial,'balance', false);
  }
}

class HomeProtectionSchemes{
  partyId: number;
  partyName: string;
  coverage: number;
  premium: number;

  constructor(initial?:HomeProtectionSchemes){
    this.partyId = get(initial,'partyId', 0);
    this.partyName = get(initial,'partyName', "");
    this.coverage = get(initial,'coverage', 0);
    this.premium = get(initial,'premium', 0);
  }
}

class ProposedPaymentAllocationPayableCpfEach{
  uin: string;
  name: string;
  amount: number;

  constructor(initial?:ProposedPaymentAllocationPayableCpfEach){
    this.uin = get(initial,'uin', "");
    this.name = get(initial,'name', "");
    this.amount = get(initial,'amount', 0);
  }
}